module.exports = __webpack_public_path__ + "img/Comic_24.d597fae3.png";